import Button from 'components/base/Button';
import Input from 'components/common/form/input/Input';
import Select from 'components/common/form/select/Select';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, Row, FormGroup, FormLabel } from 'react-bootstrap';
import * as Yup from 'yup';
import { institutionTypeOptions } from './config';
import { BasicInfo } from './institution.type';
import { useDispatch } from 'react-redux';
import { updateInstitution } from 'reducers/AuthReducer';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

const validationSchema = Yup.object({
  name: Yup.string().required('Institution name is required'),
  email: Yup.string().email().required('Institution email is required'),
  address: Yup.string().required('Address is required'),
  type: Yup.string().required('Type is required'),
  year: Yup.number()
    .required('Year Established is required')
    .min(1900, 'Year Established must be after 1900')
    .max(new Date().getFullYear(), 'Year Established cannot be in the future')
});

function Institution() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { name, email, type, address, year } = useSelector(
    (state: RootState) => state.auth.register.institution
  );

  const handleSubmit = (values: BasicInfo) => {
    dispatch(updateInstitution(values));
    navigate('/register/institution/contact');
  };
  return (
    <>
      <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">Institution Information</div>
      </div>
      <Formik
        initialValues={{
          name: name || '',
          email: email || '',
          type: type || '',
          address: address || '',
          year: year || ''
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        <Form>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="name">Name</FormLabel>
            <Input name="name" id="name" placeholder="Institution Name" />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="email">Email address</FormLabel>
            <Input
              name="email"
              id="email"
              type="email"
              placeholder="name@example.com"
            />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="type">Type</FormLabel>
            <Select name="type" id="type" options={institutionTypeOptions} />
          </FormGroup>
          <Row className="g-3 mb-3">
            <Col sm={12} lg={6}>
              <FormGroup className="mb-3 text-start">
                <FormLabel htmlFor="address">Address</FormLabel>
                <Input name="address" id="address" />
              </FormGroup>
            </Col>
            <Col sm={12} lg={6}>
              <FormGroup className="mb-3 text-start">
                <FormLabel htmlFor="year">Year Established</FormLabel>
                <Input name="year" id="year" />
              </FormGroup>
            </Col>
          </Row>
          <Button variant="primary" type="submit" className="w-100 mb-3">
            Next
          </Button>
        </Form>
      </Formik>
    </>
  );
}

export default Institution;
